import React, { useEffect, useState } from "react";
import BackButton from "../../../Components/BackButton";
import { FaCar } from "react-icons/fa";
import { useParams } from "react-router-dom";
import Handler from "../../../Helpers/Handler";
import Select from "react-select";
import DatePicker from "react-multi-date-picker";
import { toast } from "react-toastify";
import { reloadWindowToPath } from "../../../Helpers/Utils";

const Register = () => {
    const { id, associateId } = useParams()
    const [car, setCar] = useState({})
    const [brand, setBrand] = useState([])
    const [model, setModel] = useState([])
    const [variant, setVariant] = useState([])
    const [segment, setSegment] = useState([])
    const [loading, setLoading] = useState(false)
    const handleChange = (e) => setCar((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    const fuel = [{ label: "Petrol", value: "Petrol" }, { label: "Diesel", value: "Diesel" }, { label: "CNG", value: "CNG" }, { label: "EV", value: "EV" }, { value: "petCng", label: "Petrol & CNG" }, { value: "petLpg", label: "Petrol & LPG" }]
    const featureOptions = [
        { label: "Luggage", value: "Luggage" },
        { label: "Mobile Charger", value: "Mobile Charger" },
        { label: "Baby Seat", value: "Baby Seat" },
        { label: "Puncture Kit", value: "Puncture Kit" },
        { label: "Air Freshener", value: "Air Freshener" },
        { label: "Voice Control", value: "Voice Control" },
        { label: "Reverse Camera", value: "Reverse Camera" },
        { label: "Reverse Sensor", value: "Reverse Sensor" },
        { label: "Bluetooth", value: "Bluetooth" },
        { label: "AC", value: "AC" },
        { label: "Music System", value: "Music System" },
        { label: "Power Steering", value: "Power Steering" },
        { label: "Power Window", value: "Power Window" },
        { label: "Spare Tyre", value: "Spare Tyre" },
        { label: "Air Bag", value: "Air Bag" },
        { label: "Boot Space", value: "Boot Space" }
    ]
    const getVariantDetails = async (modelId) => {
        setLoading(true)
        const response = await Handler({ method: 'GET', url: `/staff/vehicle/model/${modelId}` })
        if (response?.success) {
            const data = response?.data?.data?.variants
            setVariant(data?.length ? data?.map(element => { return { label: element.variantName, value: element?.variantId } }) : [])
        } else {
            setVariant([])
        }
        setLoading(false)
    }
    const getModelDetails = async (brandId) => {
        setLoading(true)
        const response = await Handler({ method: 'GET', url: `/staff/vehicle/brand/${brandId}/model/active` })
        if (response?.success) {
            const data = response?.data?.data
            setSegment(data)
            setModel(data?.length ? data?.map(element => { return { label: element.modelName, value: element?.modelId } }) : [])
        } else {
            setModel([])
        }
        setLoading(false)
    }
    const getBrandDetails = async () => {
        setLoading(true)
        const response = await Handler({ method: 'GET', url: `/staff/vehicle/brand/active?brandType=cars` })
        if (response?.success) {
            const data = response?.data?.data
            setBrand(data?.length ? data?.map(element => { return { label: element.brand, value: element?.brandId } }) : [])
        } else {
            setBrand([])
        }
        setLoading(false)
    }
    const checkFuelType = (fuelType) => {
        if (fuelType === "petCng") {
            return ["Petrol", "CNG"]
        } else if (fuelType === "petLpg") {
            return ["Petrol", "LPG"]
        } else {
            return [fuelType]
        }
    }
    const register = async () => {
        if (!car?.variantId) {
            toast.error("Invalid Car Details")
            return
        }
        if (!car?.fuelType?.length) {
            toast.error("Invalid Fuel Type")
            return
        }
        if (car?.fuelType?.length > 2) {
            toast.error("Only upto two fuel type is allowed")
            return
        }
        if (!car?.transmissionType) {
            toast.error("Invalid Transmission Type")
            return
        }
        if (!/^[A-Z]{2}[0-9]{2}[A-Z0-9]{1,3}[0-9]{4}$/?.test(car?.registrationNo?.toUpperCase())) {
            toast.error("Invalid Registration No")
            return
        }
        if (!car?.color) {
            toast.error("Invalid Colour Details")
            return
        }
        if (!car?.features || !(car?.features instanceof Array) || car?.features?.length === 0) {
            toast.error("Kindly Select the Feature")
            return
        }
        if (!car?.year) {
            toast.error("Invalid year Details")
            return
        }

        setLoading(true)
        let url = associateId ? `carAdd/${associateId}` : `newCar`
        let data = {
            variantId: car?.variantId,
            fuelType: checkFuelType(car?.fuelType[0]?.value),
            transmissionType: car?.transmissionType,
            registrationNo: car?.registrationNo,
            color: car?.color,
            fasTag: car?.fasTag,
            year: new Date(car?.year)?.getFullYear(),
            features: car?.features?.map(element => element?.value)
        }

        const response = await Handler({ method: 'POST', url: `/staff/car/${url}`, data })
        if (response?.success) {
            toast.success(response?.data?.message)
            setTimeout(() => {
                reloadWindowToPath(`/car/details/${response?.data?.data}`)
                setLoading(false)
            }, 1500);
        } else {
            toast.error(response?.data?.message)
            setLoading(false)
        }
    }
    const update = async () => {
        if (!car?.variantId) {
            toast.error("Invalid Car Details")
            return
        }
        if (!car?.fuelType?.length) {
            toast.error("Invalid Fuel Type")
            return
        }
        if (car?.fuelType?.length > 2) {
            toast.error("Only upto two fuel type is allowed")
            return
        }
        if (!car?.transmissionType) {
            toast.error("Invalid Transmission Type")
            return
        }
        if (!/^[A-Z]{2}[0-9]{2}[A-Z0-9]{1,3}[0-9]{4}$/?.test(car?.registrationNo?.toUpperCase())) {
            toast.error("Invalid Registration No")
            return
        }
        if (!car?.color) {
            toast.error("Invalid Colour Details")
            return
        }
        if (!car?.features || !(car?.features instanceof Array) || car?.features?.length === 0) {
            toast.error("Kindly Select the Feature")
            return
        }
        if (!car?.year) {
            toast.error("Invalid year Details")
            return
        }
        setLoading(true)
        let data = {
            variantId: car?.variantId,
            fuelType: checkFuelType(car?.fuelType[0]?.value),
            transmissionType: car?.transmissionType,
            registrationNo: car?.registrationNo,
            color: car?.color,
            fasTag: car?.fasTag,
            year: new Date(car?.year)?.getFullYear(),
            features: car?.features?.map(element => element?.value)
        }
        const response = await Handler({ method: 'PATCH', url: `/staff/car/update/${id}`, data })
        if (response?.success) {
            toast.success(response?.data?.message)
            setTimeout(() => {
                reloadWindowToPath(`/car/details/${id}`)
                setLoading(false)
            }, 1500);
        } else {
            toast.error(response?.data?.message)
            setLoading(false)
        }
    }
    const getSegment = async () => setCar((prev) => ({ ...prev, segment: segment?.length ? segment?.find(element => element.modelId === car?.modelId)?.segment : "" }))
    const getCarDetails = async () => {
        setLoading(true)
        const response = await Handler({ method: 'GET', url: `/staff/car/details/${id}` })
        if (response?.success) {
            const data = response?.data?.data
            setCar(data)
            getModelDetails(data?.brand?.brandId)
            getVariantDetails(data?.model?.modelId)
            setCar((prev) => ({
                ...prev, brandId: data?.brand?.brandId, modelId: data?.model?.modelId,
                fuelType:
                    Array.isArray(data?.fuelType) ? (data?.fuelType?.length ? (
                        data?.fuelType?.includes("CNG")
                            ?
                            [{ value: "petCng", label: "Petrol & CNG" }] :
                            (data?.fuelType?.includes("LPG") ?
                                [{ value: "petLpg", label: "Petrol & LPG" }] : [{ label: data?.fuelType[0], value: data?.fuelType[0] }])) : []) : [{ label: data?.fuelType, value: data?.fuelType }],
                features: data?.features?.length ? data?.features?.map(element => { return { label: element, value: element } }) : [], year: new Date(data?.year, new Date()?.getMonth(), new Date()?.getDate())
            }))
        } else {
            setCar({})
        }
        setLoading(false)
    }
    useEffect(() => { getBrandDetails() }, [])
    useEffect(() => { if (id) getCarDetails() }, [id])
    return (
        <React.Fragment>
            <div className="container mt-4">
                <BackButton className="mb-3" />

                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="card shadow-sm border-0 rounded-4">
                            <div className="card-body p-4">
                                <div className="d-flex align-items-center mb-4">
                                    <div className="d-flex justify-content-center align-items-center me-2 rounded-3 bg-primary text-white p-2 fs-4"> <FaCar /></div>
                                    <h4 className="m-0 fw-semibold">Car {id ? "Details Update" : "Registration"}</h4>
                                </div>
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="row">
                                            <div className="col-md-12 mb-3">
                                                <label className="form-label">Brand</label>
                                                <Select styles={{
                                                    control: (base, state) => ({
                                                        ...base,
                                                        borderColor: state.isFocused ? "#44084E" : base.borderColor,
                                                        boxShadow: state.isFocused ? "0 0 0 0px #44084E" : "none",
                                                        "&:hover": { borderColor: "#44084E" }
                                                    }),
                                                    option: (style, state) => ({
                                                        ...style,
                                                        backgroundColor: state.isSelected ? "#44084E" : (state.isFocused || state.isActive) ? "#f4f0f4" : "white",
                                                        color: state.isSelected ? "white" : "black",
                                                        ":active": { ...style[":active"], backgroundColor: "#f4f0f4" }
                                                    })
                                                }}
                                                    onChange={(e) => { setCar((prev) => ({ ...prev, brandId: e?.value, modelId: '', variantId: '' })); getModelDetails(e?.value) }}
                                                    className="text-capitalize car-select"
                                                    isDisabled={loading}
                                                    options={brand} value={car?.brandId ? brand?.filter(element => element.value === car?.brandId) : ""} />
                                            </div>
                                            <div className="col-md-12 mb-3">
                                                <label className="form-label">Model</label>
                                                <Select styles={{
                                                    control: (base, state) => ({
                                                        ...base,
                                                        borderColor: state.isFocused ? "#44084E" : base.borderColor,
                                                        boxShadow: state.isFocused ? "0 0 0 0px #44084E" : "none",
                                                        "&:hover": { borderColor: "#44084E" }
                                                    }),
                                                    option: (style, state) => ({
                                                        ...style,
                                                        backgroundColor: state.isSelected ? "#44084E" : (state.isFocused || state.isActive) ? "#f4f0f4" : "white",
                                                        color: state.isSelected ? "white" : "black",
                                                        ":active": { ...style[":active"], backgroundColor: "#f4f0f4" }
                                                    })
                                                }}
                                                    onChange={(e) => { setCar((prev) => ({ ...prev, modelId: e?.value, variantId: '' })); getVariantDetails(e?.value) }}
                                                    className="text-capitalize car-select"
                                                    isDisabled={loading}
                                                    options={model} value={car?.modelId ? model?.filter(element => element.value === car?.modelId) : ""} />
                                            </div>
                                            <div className="col-md-12 mb-3">
                                                <label className="form-label">Variant</label>
                                                <Select styles={{
                                                    control: (base, state) => ({
                                                        ...base,
                                                        borderColor: state.isFocused ? "#44084E" : base.borderColor,
                                                        boxShadow: state.isFocused ? "0 0 0 0px #44084E" : "none",
                                                        "&:hover": { borderColor: "#44084E" }
                                                    }),
                                                    option: (style, state) => ({
                                                        ...style,
                                                        backgroundColor: state.isSelected ? "#44084E" : (state.isFocused || state.isActive) ? "#f4f0f4" : "white",
                                                        color: state.isSelected ? "white" : "black",
                                                        ":active": { ...style[":active"], backgroundColor: "#f4f0f4" }
                                                    })
                                                }}
                                                    onChange={(e) => { setCar((prev) => ({ ...prev, variantId: e?.value })); getSegment() }}
                                                    className="text-capitalize car-select"
                                                    isDisabled={loading}
                                                    options={variant} value={car.variantId ? variant?.filter(element => element.value === car.variantId) : ""} />
                                            </div>
                                            {/* <div className="col-md-12 mb-3">
                                                <label className="form-label">Segment</label>
                                                <input type="text" disabled name="segment" value={car?.segment || ""} className="form-control" placeholder="Enter Segment" />
                                            </div> */}
                                            <div className="col-md-12 mb-3">
                                                <label className="form-label">Fuel</label>
                                                <Select
                                                    onChange={(e) => setCar((prev) => ({ ...prev, fuelType: [e] }))}
                                                    styles={{
                                                        control: (base, state) => ({
                                                            ...base,
                                                            borderColor: state.isFocused ? '#44084E' : base.borderColor,
                                                            boxShadow: state.isFocused ? "0 0 0 0px #44084E" : "none",
                                                            minHeight: '36px',
                                                            '&:hover': {
                                                                borderColor: '#44084E',
                                                                boxShadow: 'none',
                                                            },
                                                        }),

                                                        menu: (base) => ({
                                                            ...base,
                                                            zIndex: 9999,
                                                        }),

                                                        option: (base, state) => ({
                                                            ...base,
                                                            backgroundColor: state.isSelected
                                                                ? '#44084E'
                                                                : state.isFocused
                                                                    ? '#44084E'
                                                                    : '#fff',
                                                            color: state.isSelected || state.isFocused ? '#fff' : '#000',
                                                            cursor: 'pointer',
                                                            ':active': {
                                                                backgroundColor: '#44084E',
                                                                color: '#fff',
                                                            },
                                                        }),

                                                        valueContainer: (base) => ({
                                                            ...base,
                                                            overflow: "scroll"
                                                        }),

                                                        multiValue: (base) => ({
                                                            ...base,
                                                            backgroundColor: '#44084E',
                                                            borderRadius: '2px',
                                                        }),

                                                        multiValueLabel: (base) => ({
                                                            ...base,
                                                            color: '#fff',
                                                            fontSize: '12px',
                                                            padding: '4px 6px',
                                                        }),

                                                        multiValueRemove: (base) => ({
                                                            ...base,
                                                            backgroundColor: '#fff',
                                                            color: '#44084E',
                                                            border: '1px solid #44084E',
                                                            borderRadius: '0 2px 2px 0',
                                                            cursor: 'pointer',
                                                            ':hover': {
                                                                backgroundColor: '#ff4d3215',
                                                                color: '#fff',
                                                            },
                                                        }),

                                                        placeholder: (base) => ({
                                                            ...base,
                                                            color: '#878a99',
                                                        }),

                                                        indicatorSeparator: () => ({
                                                            display: 'none',
                                                        }),

                                                        dropdownIndicator: (base) => ({
                                                            ...base,
                                                            '&:hover': {
                                                                color: '#44084E',
                                                            },
                                                        }),
                                                    }}
                                                    className="text-capitalize car-select"
                                                    isDisabled={loading}
                                                    options={fuel}
                                                    value={car.fuelType || ""}
                                                />
                                            </div>
                                            <div className="col-md-12 mb-3">
                                                <label className="form-label">Transmission</label>
                                                <Select styles={{
                                                    control: (base, state) => ({
                                                        ...base,
                                                        borderColor: state.isFocused ? "#44084E" : base.borderColor,
                                                        boxShadow: state.isFocused ? "0 0 0 0px #44084E" : "none",
                                                        "&:hover": { borderColor: "#44084E" }
                                                    }),
                                                    option: (style, state) => ({
                                                        ...style,
                                                        backgroundColor: state.isSelected ? "#44084E" : (state.isFocused || state.isActive) ? "#f4f0f4" : "white",
                                                        color: state.isSelected ? "white" : "black",
                                                        ":active": { ...style[":active"], backgroundColor: "#f4f0f4" }
                                                    })
                                                }}
                                                    onChange={(e) => { setCar((prev) => ({ ...prev, transmissionType: e?.value })); }}
                                                    className="text-capitalize car-select"
                                                    isDisabled={loading}
                                                    options={[{ label: 'Manual', value: 'Manual' }, { label: 'Automatic', value: 'Automatic' }]} value={car?.transmissionType ? { label: car.transmissionType, value: car.transmissionType } : ""} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="col-md-12 mb-3">
                                            <label className="form-label">Registration No</label>
                                            <input type="text" autoComplete="off" disabled={loading} name="registrationNo" value={car?.registrationNo || ""} onChange={handleChange} className="form-control text-uppercase" placeholder="Enter Registration No" />
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <label className="form-label">Color</label>
                                            <input type="text" autoComplete="off" disabled={loading} name="color" value={car?.color || ""} onChange={handleChange} className="form-control" placeholder="Enter Color" />
                                        </div>
                                        {/* <div className="col-md-12 mb-3">
                                            <label className="form-label">FastTag</label>
                                            <input type="text" autoComplete="off" disabled={loading} name="fasTag" value={car?.fasTag || ""} onChange={(e) => { if (e.target.value == Number(e.target.value)) handleChange(e) }} className="form-control" placeholder="Enter FastTag Balance" />
                                        </div> */}
                                        <div className="col-md-12 mb-3">
                                            <label className="form-label">Features</label>
                                            <Select
                                                styles={{
                                                    control: (base, state) => ({
                                                        ...base,
                                                        borderColor: state.isFocused ? '#44084E' : base.borderColor,
                                                        boxShadow: state.isFocused ? "0 0 0 0px #44084E" : "none",
                                                        minHeight: '36px',
                                                        '&:hover': {
                                                            borderColor: '#44084E',
                                                            boxShadow: 'none',
                                                        },
                                                    }),

                                                    menu: (base) => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                    }),

                                                    option: (base, state) => ({
                                                        ...base,
                                                        backgroundColor: state.isSelected
                                                            ? '#44084E'
                                                            : state.isFocused
                                                                ? '#44084E'
                                                                : '#fff',
                                                        color: state.isSelected || state.isFocused ? '#fff' : '#000',
                                                        cursor: 'pointer',
                                                        ':active': {
                                                            backgroundColor: '#44084E',
                                                            color: '#fff',
                                                        },
                                                    }),

                                                    valueContainer: (base) => ({
                                                        ...base,
                                                        height: "138px", overflow: "scroll"
                                                    }),

                                                    multiValue: (base) => ({
                                                        ...base,
                                                        backgroundColor: '#44084E',
                                                        borderRadius: '2px',
                                                    }),

                                                    multiValueLabel: (base) => ({
                                                        ...base,
                                                        color: '#fff',
                                                        fontSize: '12px',
                                                        padding: '4px 6px',
                                                    }),

                                                    multiValueRemove: (base) => ({
                                                        ...base,
                                                        backgroundColor: '#fff',
                                                        color: '#44084E',
                                                        border: '1px solid #44084E',
                                                        borderRadius: '0 2px 2px 0',
                                                        cursor: 'pointer',
                                                        ':hover': {
                                                            backgroundColor: '#ff4d3215',
                                                            color: '#fff',
                                                        },
                                                    }),

                                                    placeholder: (base) => ({
                                                        ...base,
                                                        color: '#878a99',
                                                    }),

                                                    indicatorSeparator: () => ({
                                                        display: 'none',
                                                    }),

                                                    dropdownIndicator: (base) => ({
                                                        ...base,
                                                        '&:hover': {
                                                            color: '#44084E',
                                                        },
                                                    }),
                                                }}
                                                maxMenuHeight={"150px"}
                                                isMulti
                                                onChange={(e) => { setCar(prev => ({ ...prev, features: e })) }}
                                                className="text-capitalize"
                                                isDisabled={loading}
                                                options={featureOptions} value={car.features || ""} />
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <label className="form-label">Year</label>
                                            <DatePicker
                                                containerClassName="w-100"
                                                inputClass="form-control"
                                                placeholder="Year"
                                                value={car.year || ""}
                                                disabled={loading}
                                                onlyYearPicker
                                                maxDate={new Date(new Date()?.setDate(new Date()?.getDate() + 1))}
                                                onChange={(date) => setCar((prev) => ({ ...prev, year: new Date(date) }))}
                                                format="YYYY"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="text-center"><button disabled={loading} className="btn btn-primary" onClick={id ? update : register}>{id ? "Update" : "Register"}</button></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Register